import { useEffect } from "react";
import { runtimeFromBrowser } from "../domain/env";

export function EnvironmentBanner() {
  const runtime = runtimeFromBrowser();

  useEffect(() => {
    document.documentElement.dataset.liftEnv = runtime.name;
    if (!runtime.banner) return;
    const previous = document.title;
    document.title = `Lift (${runtime.banner})`;
    return () => {
      document.title = previous;
    };
  }, [runtime.banner, runtime.name]);

  if (!runtime.banner) return null;

  return (
    <div className="env-banner" role="status" data-environment={runtime.name}>
      <strong>Lift</strong>
      {runtime.banner}
    </div>
  );
}
